// extracted by mini-css-extract-plugin
module.exports = {"btn":"P8nc1GDibt2WLNEIAknYU","icon":"OHS34V3hsgI6R9Eh-yiUC"};